/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ------------------------------------------------------------------
  // Stale checkout button after using the browser's back button.
  //
  // Repro: pick size L, tap "Buy with Shop" (navigates to shop.app),
  // tap back, quickly pick a different size and tap "Buy with Shop"
  // again -- checkout still shows L. Cause: mobile browsers restore this
  // page from the back-forward cache (bfcache) instead of reloading it,
  // so Shopify's `shopify-accelerated-checkout` custom element is not
  // re-created -- it's the exact same, already-initialized instance from
  // before you left, and whatever variant/checkout state it captured on
  // the first click can outlive the DOM's own inputs getting updated.
  // Force a real reload whenever this page is restored from bfcache, so
  // the payment button (and everything else) always starts fresh against
  // whatever variant is actually selected right now.
  // ------------------------------------------------------------------
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });

  // ------------------------------------------------------------------
  // Size selector: require an explicit choice before "Add to cart".
  //
  // The size dropdown (see snippets/product-variant-picker.liquid /
  // product-variant-options.liquid) no longer pre-selects a value, so the
  // hidden input Shopify/theme.js reads (`[data-popout-input]` marked with
  // `data-size-required`) starts empty. We block the add-to-cart submit
  // here, before product-form's own submit handler runs (this listener is
  // registered on `document` in the capture phase, which always fires
  // before bubble-phase listeners on the form itself), and show a subtle
  // error state instead of letting the request go through.
  // ------------------------------------------------------------------
  function getSizeSelectors(scope) {
    return scope.querySelectorAll('[data-size-selector]');
  }

  function isSizeSelected(sizeWrapper) {
    var checkedRadio = sizeWrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return true;

    var popoutInput = sizeWrapper.querySelector('[data-popout-input]');
    if (popoutInput) return popoutInput.value.trim() !== '';

    var nativeSelect = sizeWrapper.querySelector('select');
    if (nativeSelect) return nativeSelect.value.trim() !== '';

    return true;
  }

  function clearSizeError(sizeWrapper) {
    sizeWrapper.classList.remove('size-selector--missing');
    sizeWrapper.removeAttribute('aria-invalid');
  }

  function showSizeError(sizeWrapper, form) {
    sizeWrapper.classList.add('size-selector--missing');
    sizeWrapper.setAttribute('aria-invalid', 'true');

    var submitButton = form && form.querySelector('[data-add-to-cart]');
    if (!submitButton) return;

    submitButton.classList.remove('size-selector-shake');
    // Force reflow so the animation can replay on repeated attempts.
    void submitButton.offsetWidth;
    submitButton.classList.add('size-selector-shake');
  }

  // ------------------------------------------------------------------
  // Ignore a size baked into the incoming URL (?variant=...) on the very
  // first, real page load. Liquid (snippets/product-variant-picker.liquid)
  // intentionally still respects an explicit ?variant= to keep the AJAX
  // re-render that follows an in-page size pick working (see that file's
  // comments) -- but that means an OLD link pointing straight at a size
  // (e.g. a past "reserve your size" campaign link) also lands with that
  // size pre-selected, letting the customer skip the mandatory choice.
  // This runs once, synchronously, as the page's own initial script --
  // it never re-runs for the AJAX swaps triggered by picking an option on
  // this same visit, so a real in-page selection is never touched, only
  // whatever the browser navigated to this page with.
  // ------------------------------------------------------------------
  if (/(?:^|[?&])variant=/.test(window.location.search)) {
    getSizeSelectors(document).forEach(function (wrapper) {
      var popoutInput = wrapper.querySelector('[data-popout-input]');
      if (popoutInput) {
        popoutInput.value = '';
        popoutInput.removeAttribute('data-option-value-id');
        popoutInput.removeAttribute('data-product-url');
      }

      var toggleText = wrapper.querySelector('[data-popout-toggle-text]');
      if (toggleText && wrapper.hasAttribute('data-select-size-placeholder')) {
        toggleText.textContent = wrapper.getAttribute('data-select-size-placeholder');
      }

      var activeItem = wrapper.querySelector('.select-popout__item.is-active, .select-popout__item[selected]');
      if (activeItem) {
        activeItem.classList.remove('is-active');
        activeItem.removeAttribute('selected');
      }

      var currentOption = wrapper.querySelector('[aria-current="true"]');
      if (currentOption) currentOption.removeAttribute('aria-current');

      var checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedRadio) checkedRadio.checked = false;

      var nativeSelect = wrapper.querySelector('select');
      if (nativeSelect) nativeSelect.value = '';
    });
  }

  // ------------------------------------------------------------------
  // Race condition: picking a size updates the on-screen selection (and
  // the per-option hidden input `[data-popout-input]` that isSizeSelected()
  // checks) instantly, but the *actual* hidden "id" input -- the one that
  // determines what gets purchased -- is only patched ~100-300ms later,
  // once an async request to Shopify (product-info.js's renderProductInfo)
  // resolves and rewrites it. Measured live: popout input reflects the new
  // size in under 1ms, but the "id" input doesn't catch up for another
  // ~130ms. A fast tap on "Add to cart" or the payment button inside that
  // gap passes the size-selected check above yet still submits the
  // PREVIOUS (default/smallest) variant, because that's what "id" still
  // holds -- this is what caused customers to receive XS after choosing a
  // larger size on mobile. Track that gap per product and block both
  // purchase paths until "id" has actually caught up with the selection.
  // ------------------------------------------------------------------
  function getScope(el) {
    return (el.closest && el.closest('product-info')) || (el.closest && el.closest('form')) || document.body;
  }

  function isVariantPending(el) {
    var scope = getScope(el);
    return scope.getAttribute && scope.getAttribute('data-variant-pending') === 'true';
  }

  document.addEventListener(
    'change',
    function (event) {
      var scope = getScope(event.target);

      if (event.target.matches && event.target.matches('input[name="id"]')) {
        scope.removeAttribute('data-variant-pending');
        return;
      }

      if (event.target.closest && event.target.closest('[data-size-selector]')) {
        scope.setAttribute('data-variant-pending', 'true');
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-product-form')) return;

      if (isVariantPending(form)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      var scope = form.closest('product-info') || form;
      var sizeWrappers = getSizeSelectors(scope);
      if (!sizeWrappers.length) return;

      var missing = false;
      sizeWrappers.forEach(function (wrapper) {
        if (isSizeSelected(wrapper)) {
          clearSizeError(wrapper);
        } else {
          missing = true;
          showSizeError(wrapper, form);
        }
      });

      if (missing) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // ------------------------------------------------------------------
  // Apple Pay / Shop Pay / Google Pay still checking out the WRONG size
  // even with the two guards above in place.
  //
  // Root cause (confirmed by reading product-info.js on the live site):
  // when a customer changes size, `handleUpdateProductInfo` runs -- it
  // correctly updates price, inventory and the hidden "id" input
  // (dispatching a real `change` event, which is what the guards above
  // rely on). It never calls `Shopify.PaymentButton.init()`. That call
  // only happens on the *other* code path, `handleSwapProduct` (used
  // when switching to a different product), via
  // `initializeProductSwapUtility()`'s postProcessHtmlCallbacks.
  //
  // `Shopify.PaymentButton.init()` is what tells Shopify's
  // `shopify-accelerated-checkout` component which variant to check out
  // with. Without it, the component keeps using whatever variant was
  // current when the page/section was first rendered -- normally the
  // smallest available size, since size has no default pre-selection.
  // So even long after the ~130ms window the guard above accounts for,
  // Add to Cart submits the form correctly, but the dynamic checkout
  // button still starts a checkout for the *original* variant --
  // silently, with nothing to intercept client-side because no submit
  // or click ever carries the wrong data; the button's own internal
  // state is simply stale.
  //
  // product-info.js already publishes a `variant-change` event every
  // time `handleUpdateProductInfo` finishes. Subscribe to it and re-run
  // the same re-init call the swap path already does, so the dynamic
  // checkout button re-syncs to whatever size the customer actually
  // picked.
  // ------------------------------------------------------------------
  if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function () {
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
    });
  }

  // ------------------------------------------------------------------
  // Dynamic checkout buttons (Shop Pay / Apple Pay / Google Pay) never
  // submit the <form> -- Shopify's `shopify-accelerated-checkout`
  // component starts checkout directly on click, so the submit guard
  // above never runs for them. This let customers reach checkout with
  // whatever variant was already in the hidden "id" input (the first/
  // smallest size) without ever choosing a size themselves. Block the
  // click itself, in the capture phase, before Shopify's own handler
  // on the button receives it.
  // ------------------------------------------------------------------
  document.addEventListener(
    'click',
    function (event) {
      var dynamicCheckout = event.target.closest && event.target.closest('[data-shopify="payment-button"]');
      if (!dynamicCheckout) return;

      var form = dynamicCheckout.closest('form');
      if (!form) return;

      if (isVariantPending(form)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      var scope = form.closest('product-info') || form;
      var sizeWrappers = getSizeSelectors(scope);
      if (!sizeWrappers.length) return;

      var missing = false;
      sizeWrappers.forEach(function (wrapper) {
        if (isSizeSelected(wrapper)) {
          clearSizeError(wrapper);
        } else {
          missing = true;
          showSizeError(wrapper, form);
        }
      });

      if (missing) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  // Clear the error as soon as the customer picks a size.
  document.addEventListener('change', function (event) {
    var wrapper = event.target.closest && event.target.closest('[data-size-selector]');
    if (wrapper && isSizeSelected(wrapper)) clearSizeError(wrapper);
  });

  document.addEventListener('animationend', function (event) {
    if (event.target.classList.contains('size-selector-shake')) {
      event.target.classList.remove('size-selector-shake');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
